var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { uppercase } from '../transforms/uppercase';
export var baseConfig = {
    dayOfMonth: {
        options: {
            day: 'numeric',
        },
    },
    dayOfMonthOrdinal: {
        options: {
            day: 'numeric',
        },
    },
    dayOfWeekLong: {
        options: {
            weekday: 'long',
        },
    },
    dayOfWeekLongUppercase: {
        options: {
            weekday: 'long',
        },
        transforms: [uppercase],
    },
    dayOfWeekShort: {
        options: {
            weekday: 'short',
        },
    },
    dayOfWeekShortUppercase: {
        options: {
            weekday: 'short',
        },
        transforms: [uppercase],
    },
    dayOfWeekLongPropercase: {
        options: {
            weekday: 'long',
        },
    },
    dayOfWeekShortPropercase: {
        options: {
            weekday: 'short',
        },
    },
    lastDayOfWeekLong: {
        options: {
            weekday: 'long',
        },
    },
    monthNumber: {
        options: {
            month: 'numeric',
        },
    },
    monthLong: {
        options: {
            month: 'long',
        },
    },
    monthLongUppercase: {
        options: {
            month: 'long',
        },
        transforms: [uppercase],
    },
    monthShort: {
        options: {
            month: 'short',
        },
    },
    monthShortUppercase: {
        options: {
            month: 'short',
        },
        transforms: [uppercase],
    },
    monthLongPropercase: {
        options: {
            month: 'long',
        },
    },
    monthShortPropercase: {
        options: {
            month: 'short',
        },
    },
    time: {
        options: {
            timeStyle: 'short',
        },
    },
};
export var overrideBaseLocale = function (name, overrides) { return ({ name: name, options: __assign(__assign({}, baseConfig), overrides) }); };
//# sourceMappingURL=base-config.js.map